import { Spine } from '@esotericsoftware/spine-pixi-v8';
import gsap from "gsap";
import { BitmapText, Container } from 'pixi.js';
import { Group, Tween } from "tweedle.js";
import { ReelSpin } from "./ReelSpin";

import { getLineId, spinData, WinObject } from '../../server/getServerResposesFun';

import {
    REEL_DIVIDER,
    REEL_FRAME,
    REEL_NUMBERS,
    REEL_WIDTH,
    SYMBOL_HEIGHT,
    SYMBOLS_PER_REEL
} from "../../config/reelConfig";

import { sound } from "@pixi/sound";
import { isQuickBtnOnGlobal, isSuperQuickBtnOnGlobal, jurisdictionGlobal } from "../../config/GlobalVariableConfig";

let lineWinText: BitmapText;
// = new BitmapText({
//     text: '',
//     style: {
//         fontFamily: "witch_win_amount",
//         trim: true,
//         fontSize: 90,
//         // letterSpacing: 10,
//     }
// });


export interface CancellationToken {
    isCancelled: boolean;
}


let lineWinTextContainer: Container;// = new Container();
let textTweenGroup: Group;// = new Group();

export class ReelWin extends ReelSpin {


    private winSymbolArray: number[][] = [];

    public winLines: WinObject[] | null = null; // object for winning Lines
    // private winScatters: WinObject[] | null = null; // object for winning Scatters

    protected winLinesSPine: Spine | null = null;
    protected toggleWinLinesSpine: Spine | null = null;

    private currentAnimationCancellationToken: CancellationToken | null = null;
    /** Fine-tunes payline spine Y relative to the reel grid center. */
    protected paylineYOffset: number = -15;

    constructor() {
        super();

        // this.lineWinText.text = "";
        // this.lineWinText.style = style;

        // this.lineWinText.x = 500;
        // this.lineWinText.y = -100;

        // this.reelOverlayContainer.addChild(this.lineWinText);
        lineWinText = new BitmapText({
            text: '',
            style: {
                fontFamily: "3God_coin",
                trim: true,
                fontSize: 48,
                letterSpacing: 10,
            }

        });
        lineWinText.label = "lineWinText";

        lineWinTextContainer = new Container();

        textTweenGroup = new Group();

        textTweenGroup.removeAll();

        //this.setupLineWintext();

        this.setWinLineSpineObj();

    }


    public updateReelWin() {
        this.updateReelSpin();
        textTweenGroup.update();
    }


    protected getPaylineSpinePosition(): { x: number; y: number } {
        const x = (REEL_WIDTH * REEL_NUMBERS + (REEL_NUMBERS - 1) * REEL_DIVIDER) / 2;
        const y = REEL_FRAME
            + Math.round(SYMBOL_HEIGHT / 2)
            + Math.floor(SYMBOLS_PER_REEL / 2) * SYMBOL_HEIGHT
            + this.paylineYOffset;
        return { x, y };
    }

    protected setWinLineSpineObj() {
        const { x, y } = this.getPaylineSpinePosition();

        this.winLinesSPine = Spine.from({
            skeleton: "winLineSkel",
            atlas: "winLineAtlas",
        });

        this.winLinesSPine.state.clearTracks();

        this.reelOverlayContainer.addChild(this.winLinesSPine);
        this.winLinesSPine.position.set(x, y);
        this.winLinesSPine.label = "winLinesSpine";


        this.toggleWinLinesSpine = Spine.from({
            skeleton: "winLineSkel",
            atlas: "winLineAtlas",
        });

        this.toggleWinLinesSpine.state.clearTracks();

        this.toggleOverlayContainer.addChild(this.toggleWinLinesSpine);
        this.toggleWinLinesSpine.position.set(x, y);
        this.toggleWinLinesSpine.label = "toggleWinLinesSpine";
        // this.winLinesSPine?.state.setAnimation(0, "payline_5", true);
    }

    // private async waitFunction(time: number): Promise<void> {
    //     return new Promise((resolve) => {

    //         setTimeout(() => {
    //             resolve();
    //         }, time);

    //     })
    // }

    private async wait(ms: number) {
        return new Promise((resolve) => {
            new Tween({})
                .delay(ms)
                .onAfterDelay(resolve) // Resolve the promise when delay ends
                .start();
        });
    }

    private initWinSymbolArray() {
        // Initialize winSymbolArray with zeros
        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.winSymbolArray[i] = [];
            for (let j = 0; j < SYMBOLS_PER_REEL; j++) {
                this.winSymbolArray[i][j] = 0; // Initialize to 0
            }
        }
    }


    // export interface WinObject { // the object -how we want to use in our program
    //     lineId: number | null;
    //     symbolId: number;
    //     winAmount: number;
    //     winSymbolPosistions: number[][]| null;
    // }


    private setWinSymbolArray(winObjects: WinObject[]) {
        // Iterate through winLines
        winObjects?.forEach((winObject) => {
            if (winObject.winSymbolPosistions) {
                // Adjust the type of reelNum and posNum to number

                winObject.winSymbolPosistions.forEach((winSymbolPosistion) => {

                    const reelNum: number = winSymbolPosistion[0];
                    const posNum: number = winSymbolPosistion[1];

                    // Mark the position as 1
                    this.winSymbolArray[reelNum][posNum] = 1;
                })
            }
        });
    }


    // private getWinLineNmubers(): number[] {
    //     const winLineNmubers: number[] = [];//(number | null)[] | null  = null;  // define in a better way numbers[] | null

    //     this.winLines?.forEach((winLine) => {
    //         winLineNmubers.push(winLine.lineId);
    //     })

    //     return winLineNmubers;
    // }


    // this is main function which is doing the animation -
    public async animateAllWinningSymbols(currentRespinIndex: number): Promise<void> {

        return new Promise(async (resolve) => {
            this.setupLineWintext();
            if (spinData.respins[currentRespinIndex].winAmount == 0) {
                this.running = false;
                resolve();
            }
            else {

                //  this.setWinSymbolArray(this.winScatters);

                this.winLines = spinData.respins[currentRespinIndex].winLines;

                const winSymbolIds = [...new Set(this.winLines.map(line => line.symbolId))];

                for (let i = 0; i < winSymbolIds.length; i++) {
                    const symbolId = winSymbolIds[i];

                    const matchingWinLines = this.winLines.filter(line => line.symbolId === symbolId);
                    const winlineNumbers = this.getLineIdsFromWinObjects(matchingWinLines);

                    let winAmount = 0;
                    matchingWinLines.forEach((winLine) => {
                        winAmount = winAmount + winLine.winAmount;
                    })

                    this.initWinSymbolArray();
                    this.setWinSymbolArray(matchingWinLines);

                    // if (symbolId === 0) {
                    //     sound.play('wild_sound_effect', { volume: 1 });
                    // }

                    await this.animateWinLine(winlineNumbers, winAmount);

                    if (winSymbolIds.length > 1) {

                        if (!isSuperQuickBtnOnGlobal && !isQuickBtnOnGlobal) {
                            await new Promise((resolve) => setTimeout(resolve, 200));
                        }
                    }
                }

                //animate win scatters
                // this.winScatters = spinData.respins[currentRespinIndex].winScatters;

            }

            console.log("all line animations are completed");

            this.running = false; // Set running to false after all animations complete
            resolve();
        })
    }


    public resetReelOverlayContFromToggle() {
        this.toggleOverlayContainer.removeChild(this.toggleWinLinesSpine);
        this.toggleOverlayContainer.removeChild(lineWinTextContainer);

        this.reelOverlayContainer.removeChild(this.winLinesSPine);
        this.reelOverlayContainer.removeChild(lineWinTextContainer);

        if (this.winLinesSPine) {
            this.resetPaylineSpine(this.winLinesSPine);
        }
        if (this.toggleWinLinesSpine) {
            this.resetPaylineSpine(this.toggleWinLinesSpine);
        }

        if (this.currentAnimationCancellationToken !== null) {
            this.currentAnimationCancellationToken.isCancelled = true;
        }
    }

    public resetWinsOnBetChange() {
        this.winLines = [];
        this.resetReelOverlayContFromToggle();
    }


    public async lineToggle(currentRespinIndex: number) {

        if (this.running) return;   // Exit early if already running

        await this.wait(1000);

        console.log("inside lineLoggle");

        this.winLines = spinData.respins[currentRespinIndex].winLines;

        if (this.winLines == null || this.winLines == undefined) {
            return;
        }

        // --- CANCELLATION STEP 1: Create a new token for this sequence ---
        const token: CancellationToken = { isCancelled: false };
        this.currentAnimationCancellationToken = token;


        try {
            do {
                for (const winLine of this.winLines) {
                    if (!winLine || this.winLines.length <= 0) return;

                    // Add a check here as well if waitFunction is long/interruptible

                    await this.wait(250);


                    if (this.running || this.winLines.length <= 0 || token?.isCancelled) {
                        return; // Check cancellation flag here too
                    }

                    const lineId = this.resolveLineId(winLine);
                    const winAmount = winLine.winAmount;
                    const winMultiplier = winLine.winMultiplier;

                    if (lineId === null) continue;

                    this.initWinSymbolArray();
                    this.setWinSymbolArray([winLine]);

                    //adjust the layering -> winLine then symbols then winText
                    this.toggleOverlayContainer.addChild(this.toggleWinLinesSpine);

                    // this.winningSymbolOnTop();
                    this.toggleOverlayContainer.addChild(lineWinTextContainer);

                    const textAnimationY = this.getTextAnimatePos();

                    if (textAnimationY !== null) {
                        await this.animateWinTextIn(textAnimationY);
                    }

                    await Promise.all([
                        this.playPaylineAnimations(this.toggleWinLinesSpine!, [lineId], 1, token),
                        this.updateNumberText(winAmount / winMultiplier, winMultiplier, true),
                    ]);

                    //Break immediately if the next spin is called.
                    if (this.running == true || this.winLines.length <= 0 || token?.isCancelled) {
                        break;
                    }
                }

            } while (this.running == false && this.winLines.length > 0 && !token?.isCancelled);
            // Add token check to loop condition

        } catch (reason) {
            if (reason === 'cancelled') {
                console.log("lineToggle sequence exited silently due to cancellation.");
            } else {
                console.error("An unexpected error occurred:", reason);
                throw reason;
            }
        } finally {
            // --- CANCELLATION STEP 3: Cleanup the token reference ---
            if (this.currentAnimationCancellationToken === token) {
                this.currentAnimationCancellationToken = null;
            }
        }
    }


    private winningSymbolOnTop() {
        // this.reset
        // first take winning symbol on top

        // this.overlayConDarkLayer.visible = true;
        // this.reelOverlayContainer.addChild(this.overlayConDarkLayer);

        this.winSymbolArray.forEach((reels, reelNum) => {
            reels.forEach((symbol, posNum) => {
                if (symbol == 1) // win animation
                {
                    // console.log(`reelNum ${reelNum}`);
                    // console.log(`posNum ${posNum}`);

                    // take them on top
                    const symbolCont = this.reelSymbolContainers[reelNum][posNum];
                    if (symbolCont) {
                        this.reelOverlayContainer.addChild(symbolCont);
                    }

                }
            })
        })


        // then take oversized symbol on top of that
        // this.winSymbolArray.forEach((reels, reelNum) => {
        //     reels.forEach((symbol, posNum) => {
        //         if (symbol == 1) // win animation
        //         {
        //             const symbolId: number = this.allReelArray[reelNum].symbols[posNum].id;

        //             if (isOversizeSymbol(symbolId)) // symbolId of oversized symbols
        //             {
        //                 // take them on top
        //                 const symbolCont = this.reelSymbolContainers[reelNum][posNum];
        //                 if (symbolCont) {
        //                     this.reelOverlayContainer.addChild(symbolCont);
        //                 }

        //             }
        //         }
        //     })
        // })
    }


    // Function to calculate position based on lineNumber

    private resetAllSymbols() {

        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            for (let posNum = 0; posNum < SYMBOLS_PER_REEL; posNum++) {
                let symbol = this.reelSymbols[reelNum][posNum]
                symbol.tint = "0xffffff";
            }
        }
        this.resetReelOverlayContainerPositions();
    }


    protected resolveLineId(winLine: WinObject): number | null {
        if (winLine.winSymbolPosistions?.length && winLine.count > 0) {
            const lineId = getLineId(winLine.winSymbolPosistions, winLine.count);
            if (lineId !== null) {
                return lineId;
            }
        }

        return winLine.lineId;
    }

    protected getLineIdsFromWinObjects(winObjects: WinObject[]): number[] {
        const lineIds: number[] = [];

        for (const winLine of winObjects) {
            const lineId = this.resolveLineId(winLine);
            if (lineId !== null && !lineIds.includes(lineId)) {
                lineIds.push(lineId);
            }
        }

        return lineIds;
    }

    private resetPaylineSpine(spine: Spine): void {
        spine.state.clearListeners();
        spine.state.clearTracks();
        spine.skeleton.setToSetupPose();
        spine.state.data.defaultMix = 0;
        spine.update(0);
    }

    private playPaylineAnimations(
        spine: Spine,
        lineIds: number[],
        timeScale: number,
        token?: CancellationToken
    ): Promise<void> {
        return new Promise((resolve, reject) => {
            if (token?.isCancelled) {
                return reject('cancelled');
            }

            if (lineIds.length === 0) {
                return resolve();
            }

            this.resetPaylineSpine(spine);

            const animationPromises: Promise<void>[] = [];

            for (let trackIndex = 0; trackIndex < lineIds.length; trackIndex++) {
                const lineId = lineIds[trackIndex];
                const winAnimationName = `payline_${lineId + 1}`;

                const animationPromise = new Promise<void>((resolve2, reject2) => {
                    const listener = {
                        complete: () => {
                            if (token?.isCancelled) {
                                reject2('cancelled');
                            } else {
                                resolve2();
                            }
                            spine.state.removeListener(listener);
                        },
                    };

                    if (token?.isCancelled) {
                        return reject2('cancelled');
                    }

                    spine.state.addListener(listener);
                    spine.state.setAnimation(trackIndex, winAnimationName, false);
                    spine.state.timeScale = timeScale;
                });

                animationPromises.push(animationPromise);
            }

            spine.update(0);

            Promise.all(animationPromises)
                .then(() => {
                    if (token === null || !token?.isCancelled) {
                        resolve();
                    } else {
                        reject('cancelled');
                    }
                })
                .catch(reason => {
                    reject(reason);
                });
        });
    }

    private async runAnimation(winlineNumbers: number[]): Promise<void> // play animation of symbols having value 1 in the array winSymbolArray
    {

        console.log("inside runAnimation");

        let timeScale;
        if (isSuperQuickBtnOnGlobal) {
            timeScale = 2;
        }
        else {
            timeScale = 1;
        }


        let isWildWin: boolean = false;
        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            for (let posNum = 0; posNum < SYMBOLS_PER_REEL; posNum++) {
                if (this.winSymbolArray[reelNum][posNum] == 1) {
                    const symbolId = this.allReelArray[reelNum].symbols[posNum].id;
                    if (symbolId === 0) {
                        isWildWin = true;
                        break;
                    }
                }
            }
            if (isWildWin) break;
        }

        // if (isWildWin) {
        //     sound.play('wild_sound_effect', { volume: 1, speed: timeScale });
        // }

        const animationPromises: Promise<void>[] = [];

        const winLineAnimationPromise = this.playPaylineAnimations(this.winLinesSPine!, winlineNumbers, timeScale);
        animationPromises.push(winLineAnimationPromise);

        // // Clear any existing tracks
        // this.winLinesSPine?.state.clearTracks();

        // // Set paying line (numbers) - animations for each winning line
        // for (let currentLineIndex = 0; currentLineIndex < winlineNumbers.length; currentLineIndex++) {
        //     const winLineId = winlineNumbers[currentLineIndex];
        //     const winAnimationName = `payline_${winLineId + 1}`;

        //     const animationPromise = new Promise<void>((resolve) => {
        //         this.winLinesSPine.state.setAnimation(currentLineIndex, winAnimationName, false).listener = {
        //             complete: () => {
        //                 resolve();
        //                 this.winLinesSPine.state.clearListeners();
        //             }
        //         }
        //         this.winLinesSPine.state.timeScale = timeScale;
        //     })
        //     animationPromises.push(animationPromise);
        // }

        this.winSymbolArray.forEach((reels, reelNum) => {
            reels.forEach((value, posNum) => {
                let symbol = this.reelSymbols[reelNum][posNum]
                if (value == 1) {
                    const animationPromise = new Promise<void>((resolve) => {
                        let listener = {
                            complete: () => {
                                symbol.state.timeScale = 1;
                                resolve();
                                symbol.state.removeListener(listener);
                            }
                        }
                        symbol.state.addListener(listener);
                        const winAnim = symbol.skeleton.data.findAnimation("win");
                        if (winAnim) {
                            symbol.state.setAnimation(0, "win", false);
                        } else {
                            resolve();
                        }
                        symbol.state.timeScale = timeScale;
                    })

                    animationPromises.push(animationPromise);
                }
                else {
                    symbol.tint = "0x777777";
                }
            }
            )
        })

        try {
            if (animationPromises.length > 0) {
                await Promise.all(animationPromises);
            }
        } catch (error) {
            console.error("Error during runAnimation:", error);
            throw error;
        }

    }


    private async animateWinLine(winlineNumbers: number[], winAmt?: number, currentMult?: number): Promise<void> {

        console.log("animateWinLine", winlineNumbers, winAmt, currentMult);
        // // If winAmt is 0, resolve the promise immediately
        // if (winAmt === 0) {
        //     return Promise.resolve();
        // }

        currentMult = currentMult ?? 1;

        // Handle winning symbols
        this.winningSymbolOnTop();

        // Add the win lines spine to the overlay container if there are winning lines
        if (winlineNumbers.length > 0 && this.winLinesSPine) {
            this.reelOverlayContainer.addChild(this.winLinesSPine);
        }

        // on top of reelOverlayContainer
        this.reelOverlayContainer.addChild(lineWinTextContainer);

        // Initialize text animation if winAmt is non-zero
        // let textanimate: TextAnimate | null = null;
        if (winAmt) {
            // const texttickupDuration = 0;
            // const textanimationDuration = 500;
            // const decimalPlace = 2;


            const textAnimationY = this.getTextAnimatePos();

            if (textAnimationY !== null) {
                await this.animateWinTextIn(textAnimationY);
            }

            await Promise.all([
                this.runAnimation(winlineNumbers),
                this.updateNumberText(winAmt / currentMult, currentMult),
            ]);

        }
        else {
            await this.runAnimation(winlineNumbers);
        }

        this.resetAllSymbols()

    }

    private setupLineWintext() {

        lineWinTextContainer.label = "lineWinTextContainer";
        lineWinText.anchor = 0.5;
        lineWinTextContainer.addChild(lineWinText);

        this.reelOverlayContainer.addChild(lineWinTextContainer);

        // new TextAnimate(textTweenGroup, winAmt, decimalPlace, texttickupDuration, textanimationDuration);
        lineWinTextContainer.x = (REEL_WIDTH * REEL_NUMBERS + (REEL_NUMBERS - 1) * REEL_DIVIDER) / 2;

    }


    // private getTextAnimatePos(): number {

    //     const mappedArray = this.winSymbolArray[0].map((_, colIndex) =>
    //         this.winSymbolArray.some(row => row[colIndex] === 1) ? 1 : 0
    //     );

    //     // Step 2: Get indexes with 1s
    //     const indexesWithOnes = mappedArray
    //         .map((value, index) => (value === 1 ? index : -1))
    //         .filter(index => index !== -1);

    //     // Step 3: Calculate Median
    //     let median: number;
    //     const len = indexesWithOnes.length;

    //     if (len === 0) {
    //         median = -1; // Handle case with no 1s
    //     } else if (len % 2 === 0) {
    //         median = (indexesWithOnes[len / 2 - 1] + indexesWithOnes[len / 2]) / 2;
    //     } else {
    //         median = indexesWithOnes[Math.floor(len / 2)];
    //     }

    //     console.log("this.winSymbolArray:", this.winSymbolArray);
    //     console.log("Mapped Array:", mappedArray);        // [1, 1, 1, 1, 1, 0]
    //     console.log("Indexes with 1s:", indexesWithOnes); // [0, 1, 2, 3, 4]
    //     console.log("Median index:", median);             // 2

    //     return (median + 0.5) * SYMBOL_HEIGHT;

    // }

    // private getTextAnimatePosToggle(): number {

    //     const mappedArray = this.winSymbolArray[0].map((_, colIndex) =>
    //         this.winSymbolArray.some(row => row[colIndex] === 1) ? 1 : 0
    //     );

    //     // Step 2: Get indexes with 1s
    //     const indexesWithOnes = mappedArray
    //         .map((value, index) => (value === 1 ? index : -1))
    //         .filter(index => index !== -1);

    //     // Step 3: Calculate Median
    //     let median: number;
    //     const len = indexesWithOnes.length;

    //     if (len === 0) {
    //         median = -1; // Handle case with no 1s
    //     } else if (len % 2 === 0) {
    //         median = (indexesWithOnes[len / 2 - 1] + indexesWithOnes[len / 2]) / 2;
    //     } else {
    //         median = indexesWithOnes[Math.floor(len / 2)];
    //     }

    //     // console.log("Mapped Array:", mappedArray);        // [1, 1, 1, 1, 1, 0]
    //     // console.log("Indexes with 1s:", indexesWithOnes); // [0, 1, 2, 3, 4]
    //     // console.log("Median index:", median);             // 2

    //     return (median + 0.5) * SYMBOL_HEIGHT;

    // }


    private getTextAnimatePos(): number | null {
        if (!this.winSymbolArray || this.winSymbolArray.length === 0) {
            return null;
        }

        // Step 1: Find the middle row index
        const middleIndex =
            this.winSymbolArray.length % 2 === 0
                ? this.winSymbolArray.length / 2
                : Math.floor(this.winSymbolArray.length / 2);

        const middleRow = this.winSymbolArray[middleIndex];
        if (!middleRow) return null;

        // Step 2: Find indices where value === 1
        const oneIndices = middleRow
            .map((value, index) => (value === 1 ? index : -1))
            .filter(index => index !== -1);

        if (oneIndices.length === 0) {
            return null;
        }

        // Step 3: Calculate offset
        if (oneIndices.length === 1) {
            return (oneIndices[0] + 0.5) * SYMBOL_HEIGHT;
        } else {
            // Take average of first and last active indices
            return ((oneIndices[0] + oneIndices[oneIndices.length - 1]) / 2 + 0.5) * SYMBOL_HEIGHT;
        }
    }


    private async updateNumberText(winAmt: number, currentMult?: number, callFromToggle?: boolean): Promise<void> {
        // console.log(`currentMult ${currentMult}`);

        return new Promise(async (resolve) => {

            if (isSuperQuickBtnOnGlobal && !callFromToggle) {

                let targetVal: number = winAmt * currentMult;
                lineWinText.text = `${(targetVal).toFixed(2)}`;

                lineWinText.scale = 1;
                const textScale = Math.min(850 / lineWinText.width, 1);
                lineWinText.scale = textScale;

                if (["uk", "ontario"].indexOf(jurisdictionGlobal) !== -1 && !spinData.isWinHigherBet) {
                    sound.play('symbol_win', { volume: 0.4 })
                }
                else {
                    if (callFromToggle !== true) {
                        sound.play('symbol_win', { volume: 1 })
                    }
                }

                await this.wait(500);

                lineWinText.text = "";
                lineWinText.scale = 1;
                lineWinText.alpha = 1;

                await this.wait(500);

                resolve();

                return;
            }


            // if super turbo is not there

            if (currentMult && currentMult > 1) {
                lineWinText.text = `${winAmt.toFixed(2)} x ${currentMult}`;
            }
            else {
                lineWinText.text = `${winAmt.toFixed(2)}`;
            }

            lineWinText.scale = 1;
            const textScale = Math.min(850 / lineWinText.width, 1);
            lineWinText.scale = textScale;
            // lineWinText.alpha = 0;
            lineWinText.scale.set(textScale * 0.8);

            // new Tween(lineWinText, textTweenGroup)
            //     .to({ alpha: 1 }, 150)
            //     .start();

            new Tween(lineWinText.scale, textTweenGroup)
                .to({ x: textScale, y: textScale }, 150)
                .start();

            if (["uk", "ontario"].indexOf(jurisdictionGlobal) !== -1 && !spinData.isWinHigherBet) {
                sound.play('symbol_win', { volume: 0.4 })
            }
            else {
                // sound.play('symbol_win', { volume: .3 })
                if (callFromToggle !== true) {
                    sound.play('symbol_win', { volume: 1 })
                }
            }

            // await new Promise(resolve => setTimeout(resolve, 500));

            if (currentMult && currentMult > 1) {

                let currentVal: number = winAmt;
                let targetVal: number = winAmt * currentMult;
                const tweenToTickup = new Tween({ x: currentVal }, textTweenGroup)
                    .to({ x: targetVal }, 100)
                    .onStart(() => {
                        // sound.play('symbol_win_multiply', { volume: 0.2 });

                        if (["uk", "ontario"].indexOf(jurisdictionGlobal) !== -1 && !spinData.isWinHigherBet) {
                            sound.play('symbol_win_multiply', { volume: 0.15 })
                        }
                        else {
                            if (callFromToggle !== true) {
                                sound.play('symbol_win_multiply', { volume: 0.35 })
                            }
                        }
                    })
                    .onUpdate((object) => {
                        lineWinText.text = `${(currentVal).toFixed(2)}`;
                        currentVal = object.x; // Update currentVal with the tweened value
                        // console.log(`in tween currentVal: ${currentVal}`);
                    })
                    .onComplete(() => {
                        lineWinText.text = `${(targetVal).toFixed(2)}`;
                        textTweenGroup.remove(tweenToTickup)
                    })
                    .start();

                await this.wait(500);

            }
            else {
                await this.wait(500);
            }
            await this.floatWinText(200);

            await this.animateWinTextOut();

            lineWinText.text = "";
            lineWinText.scale = 1;

            resolve();
        })

    }

    private async animateWinTextIn(baseY: number): Promise<void> {
        return new Promise((resolve) => {

            gsap.killTweensOf(lineWinTextContainer);
            gsap.killTweensOf(lineWinTextContainer.scale);

            lineWinTextContainer.alpha = 0;
            lineWinTextContainer.y = baseY + 40;
            lineWinTextContainer.rotation = -0.08;
            lineWinTextContainer.scale.set(0.75);

            const tl = gsap.timeline({
                onComplete: resolve
            });

            tl.to(lineWinTextContainer, {
                alpha: 1,
                y: baseY,
                rotation: 0.02,
                duration: 0.35,
                ease: "back.out(2)"
            })
                .to(
                    lineWinTextContainer.scale,
                    {
                        x: 1.18,
                        y: 1.18,
                        duration: 0.18,
                        ease: "back.out(3)"
                    },
                    0
                )
                .to(
                    lineWinTextContainer.scale,
                    {
                        x: 1,
                        y: 1,
                        duration: 0.15,
                        ease: "power2.out"
                    }
                )
                .to(
                    lineWinTextContainer,
                    {
                        rotation: 0,
                        duration: 0.12,
                        ease: "power2.out"
                    },
                    "<"
                );
        });
    }

    private async floatWinText(duration: number): Promise<void> {

        this.startWinTextFloating();

        await new Promise(resolve =>
            gsap.delayedCall(duration / 1000, resolve)
        );

        this.stopWinTextFloating();
    }

    private async animateWinTextOut(): Promise<void> {
        return new Promise((resolve) => {

            this.stopWinTextFloating();

            gsap.to(lineWinTextContainer, {
                alpha: 0,
                y: lineWinTextContainer.y - 40,
                rotation: 0.05,
                duration: 0.25,
                ease: "power2.in",
                onComplete: () => {

                    lineWinTextContainer.alpha = 1;
                    lineWinTextContainer.rotation = 0;

                    gsap.set(lineWinTextContainer.scale, {
                        x: 1,
                        y: 1
                    });

                    resolve();
                }
            });

            gsap.to(lineWinTextContainer.scale, {
                x: 0.85,
                y: 0.85,
                duration: 0.25,
                ease: "power2.in"
            });
        });
    }

    private lineWinFloatTimeline?: gsap.core.Timeline;

    private startWinTextFloating(): void {

        this.stopWinTextFloating();

        const baseY = lineWinTextContainer.y;
        const baseScale = 1;

        this.lineWinFloatTimeline = gsap.timeline({
            repeat: -1,
            yoyo: true
        });

        this.lineWinFloatTimeline
            .to(
                lineWinTextContainer,
                {
                    y: baseY - 6,
                    rotation: 0.015,
                    duration: 1.2,
                    ease: "sine.inOut"
                },
                0
            )
            .to(
                lineWinTextContainer.scale,
                {
                    x: baseScale * 1.04,
                    y: baseScale * 1.04,
                    duration: 1.2,
                    ease: "sine.inOut"
                },
                0
            );
    }

    private stopWinTextFloating(): void {

        this.lineWinFloatTimeline?.kill();
        this.lineWinFloatTimeline = undefined;

        gsap.set(lineWinTextContainer, {
            rotation: 0
        });

        gsap.set(lineWinTextContainer.scale, {
            x: 1,
            y: 1
        });
    }


}